import _ from "lodash";

interface OrderItem {
  order_ids: string[];
  amount_to_collect: number;
}

interface OrderMarkingMap {
  [key: string]: {
    key: string;
  };
}

const getNum = (num: number | string): number =>
  _.isFinite(Number(num)) ? Number(num) : 0;

export const calculateTotalPayableAmount = (
  listData: OrderItem[],
  orderMarkingMap: OrderMarkingMap,
  precision: number = 2,
): number => {
  const nums = listData.map((item) => {
    const isOrderCancelled =
      orderMarkingMap[item.order_ids[0]]?.key === "CANCEL_DELIVERY" ||
      orderMarkingMap[item.order_ids[0]]?.key === "CX_RTO";
    return isOrderCancelled ? 0 : item.amount_to_collect;
  });
  return Number(
    nums.reduce((acc, curr) => acc + getNum(curr), 0).toFixed(precision),
  );
};
